import { Pais } from './Pais';

export class Estado {
    id = 0;
    nome = '';
    uf = '';
    pais = new Pais();
}